import { KEYS } from '../../../../../../../../../l18n/constants';
import computeClassName from '../../../../../../../../../utils/computeClassName';
import { useL18nContext } from '../../../../../../../ContextProvider/L18n';
import { usePartnerSearchContext } from "../../../../../../../ContextProvider/Partner/Search";

const constants = Object.freeze({
  CLASSNAME_BASE: 'whitespace-nowrap font-normal text-cc-body-medium sm:text-cc-body-large text-cc-primary-contrast'
});

const propsDefaults = Object.freeze({
  resultCount: 0
});

function getComputedResultsInLabel(count, searchCriteria, getTranslationFor) {
//  const searchCriteriaLength = searchCriteria?.length||0;
//  if (searchCriteriaLength === 0) {
    switch (count) {
      case 0:
        return getTranslationFor(KEYS.L18N_KEY_LABEL_NO_RESULTS);
      case 1:
        return getTranslationFor(KEYS.L18N_KEY_LABEL_RESULT);
      default:
        return getTranslationFor(KEYS.L18N_KEY_LABEL_RESULTS);
    }
//  }
//  else {
//    switch (count) {
//      case 0:
//        return `${getTranslationFor(KEYS.L18N_KEY_LABEL_NO_RESULTS_IN)}:`;
//      case 1:
//        return `${getTranslationFor(KEYS.L18N_KEY_LABEL_RESULT_IN)}:`;
//      default:
//        return `${getTranslationFor(KEYS.L18N_KEY_LABEL_RESULTS_IN)}:`;
//    }
//  }
}

export default function MatchingResultCount(
  {
    resultCount = propsDefaults.resultCount,
    className = ''
  }) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { currentLocale, getTranslationFor } = useL18nContext();
  const { searchCriteria } = usePartnerSearchContext();

  const computedResultsInLabel = getComputedResultsInLabel(resultCount, searchCriteria, getTranslationFor);
  const formattedFoundPartnerCount = new Intl.NumberFormat(currentLocale).format(resultCount);

  return (
    <span className={computedClassName}>
      {
        (resultCount > 0) &&
        <span className="mr-cc-1char">{formattedFoundPartnerCount}</span>
      }
      <span>{computedResultsInLabel}</span>
    </span>
  );
}
